$( document ).ready( () => {

	$( '.js-slider-testimonials' ).each( function() {
		var slidesNumberDesktop = $( this ).data( 'desktop' );
		var slidesNumberTablet  = $( this ).data( 'tablet' );
		var slidesNumberMobile  = $( this ).data( 'mobile' );
		var navigationNext      = $( this ).parents( '.slider-testimonials-wrap' ).find('.swiper-button-next')[0];
		var navigationPrev      = $( this ).parents( '.slider-testimonials-wrap' ).find('.swiper-button-prev')[0];

		new Swiper( this, {
			loop:          true,
			autoHeight:    true,
			slidesPerView: 4,
			spaceBetween:  40,
			pagination:    {
				el:        $( this ).find( '.swiper-pagination' )[0],
				clickable: true,
			},
			navigation: {
				nextEl: navigationNext,
				prevEl: navigationPrev,
			},
			breakpoints: {
				300: {
					slidesPerView: slidesNumberMobile,
					spaceBetween:  20,
				},
				767: {
					slidesPerView: slidesNumberTablet,
					spaceBetween:  20,
				},
				1199: {
					slidesPerView: slidesNumberDesktop,
					spaceBetween:  40,
				},
			},
		} );
	} );
} );
